import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { AddBox } from "@material-ui/icons";
import { Box, Button } from "@material-ui/core";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import AccessListTable from "./AccessListTable";
import AddUserAccessDialog from "./AddUserAccessDialog";
import AddBatchAccessDialog from "./AddBatchAcessDialog";
import CmtSearch from "@coremat/CmtSearch";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  scrollbarRoot: {
    height: 275,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const AccessList = ({ isALManamger }) => {
  const classes = useStyles();
  const [openAddUser, setOpenAddUser] = useState(false);
  const [openAddBatchUser, setOpenAddBatchUser] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Box>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddToPhotosIcon />}
              onClick={() => setOpenAddBatchUser(true)}
              style={{ marginBlock: "10px" }}
            >
              اضافه کردن گروهی
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddBox />}
              onClick={() => setOpenAddUser(true)}
              style={{ marginRight: 14, marginBlock: "10px" }}
            >
              اضافه کردن دسترسی
            </Button>
          </Box>
        </Box>
        <AccessListTable
          searchMode={searchVal.trim().length > 0}
          searchInput={searchVal}
          isALManamger={isALManamger}
        />
      </CmtCardContent>
      <AddUserAccessDialog
        open={openAddUser}
        handleClose={() => setOpenAddUser(false)}
        isALManamger={isALManamger}
      />
      <AddBatchAccessDialog
        open={openAddBatchUser}
        handleClose={() => setOpenAddBatchUser(false)}
        isALManamger={isALManamger}
      />
    </CmtCard>
  );
};

export default AccessList;
